module.exports = __webpack_public_path__ + "media/images/community_stories/your_community_10-4d6db6d4ca6a951dbab9d54b58e9211f.jpg";